/* Derived view-model for the engine route.
 * GENERATED from the original artifact's vals_engine() by
 * tools/convert-logic.py; edits since generation are tracked in git. */
import { FOOTER_COLS } from '@/data/wft';

export function engineVals() {
  return {
    footerCols: FOOTER_COLS,
    lanes: [
      {
        name: 'TimesFM 2.5',
        color: 'var(--wft-engine)',
        module: 'temporal/ · wft/forecast/',
        answers: 'how wide is the distribution around this series',
        feeds: 'Forecast Lab · forecast columns · Divergence · Record',
        body: 'A foundation time-series model, vendored byte-verbatim from god-engine and verified against a lockfile. Any series the product holds can be sent to it, with horizon and transform chosen in the lab.',
      },
      {
        name: 'Swarm resolve',
        color: 'var(--wft-scenario)',
        module: 'wft/godengine/client.py',
        answers: 'which futures are on the table and how heavy each one is',
        feeds: 'Scenarios · Simulation · Regimes',
        body: 'GodEngine\u2019s resolver streams branching futures with probability mass, assumptions and triggers per branch. It is the other half of the engine, not a different product.',
      },
    ],
    path: [
      {
        n: '1',
        step: 'Series',
        body: 'A named series is selected — from yfinance, FRED, CoinGecko or any bound connector.',
        refuses: 'the connector is unbound',
      },
      {
        n: '2',
        step: 'History',
        body: 'Observed history is read from Postgres, with its as-of stamp from the last successful fetch.',
        refuses: 'history is shorter than the context window',
      },
      {
        n: '3',
        step: 'Weights',
        body: 'The forecast worker loads the model file already verified on local disk.',
        refuses: 'size or sha256 does not match',
      },
      {
        n: '4',
        step: 'Forecast',
        body: 'TimesFM 2.5 returns a median and the quantile band for the chosen horizon.',
        refuses: 'the decoder is the polyfit fallback',
      },
      {
        n: '5',
        step: 'Record',
        body: 'The forecast is written down with horizon, quantiles, baseline and decoder before any outcome exists.',
        refuses: 'never — recording precedes display',
      },
      {
        n: '6',
        step: 'Render',
        body: 'The panel draws observed in data ink and the forecast in engine ink, with provenance beside it.',
        refuses: 'decoder_name is StubDecoder',
      },
    ],
    integrity: [
      {
        n: '01',
        step: 'temporal/ is a byte-verbatim copy of god-engine\u2019s TimesFM layer.',
        where: 'verified against temporal/VENDOR.lock',
      },
      {
        n: '02',
        step: 'A modified vendored file fails the build rather than shipping quietly.',
        where: 'scripts/vendor_sync.py --check in CI',
      },
      {
        n: '03',
        step: 'Weights are fetched from a local path or a release, never from git.',
        where: 'scripts/fetch_weights.py',
      },
      {
        n: '04',
        step: 'Size and sha256 are checked against the recorded checksums.',
        where: 'weights/CHECKSUMS.txt',
      },
      {
        n: '05',
        step: 'Only a verified file is moved into place, atomically.',
        where: '925,181,104 bytes',
      },
    ],
    provenance: [
      {
        field: 'decoder_name',
        what: 'Which decoder produced this. The fallback is visible, not hidden.',
      },
      {
        field: 'horizon',
        what: 'How far ahead, fixed at write time and never re-chosen after the fact.',
      },
      { field: 'q20 / q50 / q80', what: 'The quantile band drawn as the fan.' },
      { field: 'baseline', what: 'Random walk, scored alongside so skill is measurable.' },
      {
        field: 'as_of',
        what: "The server's last successful fetch of the input series, never the browser clock.",
      },
      { field: 'source', what: 'The named connector behind the input series.' },
      { field: 'run_id', what: 'Ties this forecast to its row in the ledger when it resolves.' },
    ],
    appearances: [
      {
        mnemonic: 'FCST',
        title: 'Forecast Lab',
        body: 'Pick a series, horizon and transform; read the fan and its provenance.',
      },
      {
        mnemonic: 'REC',
        title: 'Track Record',
        body: 'Resolved forecasts, coverage, calibration and skill by horizon.',
      },
      {
        mnemonic: 'DIV',
        title: 'Divergence',
        body: 'Where the engine most disagrees with the baseline, and whether that paid.',
      },
      {
        mnemonic: 'SCN',
        title: 'Scenarios',
        body: 'Branch tree and probability mass from the swarm resolver.',
      },
      {
        mnemonic: 'SIM',
        title: 'Simulation',
        body: 'Push a shock and watch it propagate through the linkage graph.',
      },
      {
        mnemonic: 'MKT',
        title: 'Every tape section',
        body: 'An engine column beside the observed one, never in the same ink.',
      },
    ],
    commitments: [
      {
        label: 'Quantiles, not a point',
        body: 'A single line implies a confidence the model does not have. Every forecast ships q20, q50 and q80.',
      },
      {
        label: 'A baseline travels with it',
        body: 'Skill is measured against a random walk. Without a baseline a forecast can only be admired, not judged.',
      },
      {
        label: 'Written before scored',
        body: 'The horizon is fixed at write time. Nothing is re-chosen once the outcome is known.',
      },
      {
        label: 'The fallback is loud',
        body: 'A polyfit stub is plausible and therefore dangerous. It draws nothing and says why.',
      },
      {
        label: 'Vendored, not forked',
        body: 'The model layer stays read-only and verified; product behaviour lives beside it, not inside it.',
      },
      {
        label: 'Engine ink only',
        body: 'Forecasts never borrow the colour of an observed number, in any theme or colourblind mode.',
      },
    ],
  };
}

export type EngineVals = ReturnType<typeof engineVals>;
